import React from 'react';

import { WorkflowLayout as SharedWorkflowLayout, useFeatureFlag } from '@betterment/shared-components';
import { ColorModeControls } from '@betterment/shared-components/src/components/color-mode/ColorModeControls';

import NoticeCollection from '../../InAppMessages/GlobalNotices/NoticeCollection';
import { Notifications } from '../../notifications/Notifications';
import Footer from '../components-v2/footer/Footer';

interface LayoutProps {
  size?: 'small' | 'medium' | 'large' | 'full';
  pageTitle: string | null;
  workflowTitle: string | null;
  onBack?: () => void;
  onClose: () => void;
  onLogoClick?: () => void;
}

export const WorkflowLayout: React.FC<React.PropsWithChildren<LayoutProps>> = ({
  children,
  workflowTitle,
  onBack,
  onClose,
  onLogoClick,
  size,
  pageTitle,
}) => {
  const colorModeControlsFlag = useFeatureFlag({
    splitName: 'retail.color_mode_controls_q4_2024_enabled',
    context: 'WithLayout',
  });

  return (
    <SharedWorkflowLayout pageTitle={pageTitle}>
      <SharedWorkflowLayout.Banner>
        <NoticeCollection css={{ gridColumnStart: 2 }} />
        <Notifications css={{ gridColumnStart: 2, py: 'space.300', px: 'space.400' }} />
      </SharedWorkflowLayout.Banner>
      <SharedWorkflowLayout.Header
        workflowTitle={workflowTitle}
        onBack={onBack}
        onLogoClick={onLogoClick}
        onClose={onClose}
      />
      <SharedWorkflowLayout.Content size={size}>{children}</SharedWorkflowLayout.Content>
      <SharedWorkflowLayout.Footer>
        <Footer />
        {colorModeControlsFlag.enabled && <ColorModeControls />}
      </SharedWorkflowLayout.Footer>
    </SharedWorkflowLayout>
  );
};
